var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14386 13.9718C3.33408 13.9718 0.234375 10.8721 0.234375 7.06232C0.234375 3.25253 3.33408 0.152832 7.14386 0.152832C10.9536 0.152832 14.0533 3.25253 14.0533 7.06232C14.0533 10.8721 10.9536 13.9718 7.14386 13.9718ZM7.14386 1.21583C3.91979 1.21583 1.29737 3.83825 1.29737 7.06232C1.29737 10.2853 3.91979 12.9088 7.14386 12.9088C10.3679 12.9088 12.9904 10.2853 12.9904 7.06232C12.9904 3.83825 10.3679 1.21583 7.14386 1.21583Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57949 9.98567C9.47328 9.98567 9.36512 9.9506 9.27548 9.87946L6.83944 7.93063C6.72348 7.83806 6.65625 7.69775 6.65625 7.54964V4.13918C6.65625 3.87025 6.87452 3.65198 7.14346 3.65198C7.4124 3.65198 7.63066 3.87025 7.63066 4.13918V7.31578L9.88351 9.11845C10.093 9.28702 10.1271 9.59298 9.95952 9.80346C9.86402 9.92331 9.72176 9.98567 9.57949 9.98567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.70ca0f471a0b20e0a88406bc742e56d9.svg";
export { ForwardRef as ReactComponent };